<template>
  <div>
    <top-menu-card
      mark="E"
      icon="mdi-file-download"
      :color="color">
      <template #title>
        E. 報告書の出力
      </template>
      <template #subtitle>
        報告書の出力に必要な最終項目を入力し、報告書PDFを作成します。
      </template>
      <template #actions>
        <v-spacer />
        <v-btn
          :color="color"
          outlined
          @click.prevent="onInputClicked">
          入力する
          <v-icon dense>mdi-arrow-right</v-icon>
        </v-btn>
      </template>
    </top-menu-card>
    <unsaved-session-confirm
      v-if="confirmDialog"
      v-model="confirmDialog"
      session-name="report"
      route-name-new="reportEditStep1"
      route-name-continue="reportEditStep2"
      @cancel="confirmDialog=false" />
  </div>
</template>

<script>
import TopMenuCard from './TopMenuCard'
import UnsavedSessionConfirm from '../UnsavedSessionConfirm'

export default {
  name: 'TopReportMenu',
  components: { UnsavedSessionConfirm, TopMenuCard },
  props: {
    color: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      confirmDialog: false,
    }
  },
  methods: {
    // 入力ボタン
    onInputClicked() {
      this.$router.push({ name: 'reportEditStep1' })
    },
  },
}
</script>
